import { ReactNode, useState } from 'react';

import { type RelatedProductsResult } from './types';
import { createSafeContext } from '../safe-context';
import {
  ProductDetailsFragment,
  ProductVariantDetailsWihoutProductFragment,
  ProductCardFragment,
} from '../saleor-graphql';

interface IProductDetailsContext {
  product: ProductDetailsFragment;
  variant: ProductVariantDetailsWihoutProductFragment;
  relatedProductsGroups?: RelatedProductsResult[];
  isAvailable?: boolean | null;
  quantity: number;
  setQuantity: React.Dispatch<React.SetStateAction<number>>;
}

const [useOldProductDetails, DetailsProvider] = createSafeContext<IProductDetailsContext>();

const OldProductDetailsProvider = ({
  product,
  variant,
  children,
  relatedProductsGroups,
}: { children: ReactNode } & Omit<
  IProductDetailsContext,
  'isAvailable' | 'quantity' | 'setQuantity'
>) => {
  const [quantity, setQuantity] = useState(1);

  return (
    <DetailsProvider
      value={{
        product,
        variant,
        isAvailable: Boolean(product.isAvailable),
        quantity,
        relatedProductsGroups,
        setQuantity,
      }}
    >
      {children}
    </DetailsProvider>
  );
};

interface IProductCardContext {
  product: ProductCardFragment;
}

const [useOldProductCard, Provider] = createSafeContext<IProductCardContext>();

const OldProductCardProvider = ({
  product,
  children,
}: { children: ReactNode } & IProductCardContext) => {
  return <Provider value={{ product }}>{children}</Provider>;
};

export { useOldProductDetails, OldProductDetailsProvider, useOldProductCard, OldProductCardProvider };